module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "sketch",
    class: {
      sketchExpend: _vm.isExpand
    }
  }, [_c('ul', _vm._l((_vm.datasets), function(item) {
    return _c(item.component, {
      tag: "li",
      attrs: {
        "data": item
      },
      on: {
        "activeSwitch": _vm.activeChange
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d28886f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuBar.vue
// module id = 100
// module chunks = 0